import React, { useRef, useState } from "react";
import "./Articles.css"; 
import { useLanguage } from "../LanguageContext";

// Import images
import IM1 from "../images/IM1.jpg";
import IM2 from "../images/IM2.jpg";
import IM3 from "../images/IM3.jpg";
import IM4 from "../images/IM4.jpg";
import IM5 from "../images/IM5.JPG";
import IM6 from "../images/IM6.jpeg";
import souffleLogo from "../images/souffle_inedit.png";

const articles = [
  {
    id: "souffle-main",
    title_ar: "Souffle Inédit",
    title_fr: "Souffle Inédit",
    title_en: "Souffle Inédit",
    author_ar: "جميع المقالات على منصة Souffle Inédit",
    author_fr: "Retrouvez tous mes articles sur Souffle Inédit",
    author_en: "Read all my articles on Souffle Inédit",
    image: souffleLogo,
    link: "https://souffleinedit.com/author/hajar-ouhsine/",
    isSpecial: true // To style it differently if needed
  },
  {
    id: 1,
    title_ar: "أضغاث أحلام",
    title_fr: "Fragments de Rêves",
    title_en: "Dream Fragments",
    author_ar: "جريدة بيان اليوم",
    author_fr: "Journal Bayane Al Yaoum",
    author_en: "Bayane Al Yaoum newspaper",
    image: IM1,
    link: "#"
  },
  {
    id: 2,
    title_ar: "سحر الكلمات",
    title_fr: "La magie des mots",
    title_en: "The Magic of Words",
    author_ar: "جريدة بيان اليوم",
    author_fr: "Journal Bayane Al Yaoum",
    author_en: "Bayane Al Yaoum newspaper",
    image: IM2,
    link: "#"
  },
  {
    id: 3,
    title_ar: "بين الماضي والمستقبل، عدو لدود",
    title_fr: "Entre passé et futur, un ennemi juré",
    title_en: "Between past and future, a sworn enemy",
    author_ar: "جريدة بيان اليوم",
    author_fr: "Journal Bayane Al Yaoum",
    author_en: "Bayane Al Yaoum newspaper",
    image: IM3,
    link: "#"
  },
  {
    id: 4,
    title_ar: "الشمس السوداء",
    title_fr: "Le soleil noir",
    title_en: "The Black Sun",
    author_ar: "قصة قصيرة - جريدة بيان اليوم",
    author_fr: "Nouvelle - Journal Bayane Al Yaoum",
    author_en: "Short story - Bayane Al Yaoum newspaper",
    image: IM4,
    link: "#"
  },
  {
    id: 5,
    title_ar: "على الشمس أيضا تتهاطل الأمطار",
    title_fr: "Les noces poétiques de la pluie et du soleil",
    title_en: "The poetic wedding of rain and sun",
    author_ar: "جريدة AL BAYANE",
    author_fr: "Journal AL BAYANE",
    author_en: "AL BAYANE newspaper",
    image: IM5,
    link: "#"
  },
  {
    id: 6,
    title_ar: "متوازيان لكنهما.. قد يلتقيان مجددا..",
    title_fr: "Parallèles, mais ils pourraient se croiser à nouveau..",
    title_en: "Parallel, but they might meet again..",
    author_ar: "الملحق الثقافي لجريدة بيان اليوم",
    author_fr: "Supplément culturel du journal Bayane Al Yaoum",
    author_en: "Cultural supplement of Bayane Al Yaoum newspaper",
    image: IM6,
    link: "#"
  },
];

const Articles = () => {
  const { language } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const scrollContainerRef = useRef(null);

  const openModal = (imgSrc) => setSelectedImage(imgSrc);
  const closeModal = () => setSelectedImage(null);

  const scroll = (direction) => {
    const { current } = scrollContainerRef;
    const scrollAmount = 350; // Width of a card + gap
    if (direction === 'left') {
      current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="new-articles-section">
      <h2 className="section-title new-articles-title">
        {language === 'ar' ? 'مقالات' : language === 'fr' ? 'Articles' : 'Articles'}
      </h2>
      
      <div className="carousel-wrapper">
        <button className="carousel-nav-btn prev" onClick={() => scroll('left')}>&#8249;</button>
        
        <div className="new-articles-container" ref={scrollContainerRef}>
          {articles.map((article) => (
            <div className="new-article-card" key={article.id}>
              <div className="article-image-wrapper">
                <img
                  src={article.image}
                  alt={language === 'ar' ? article.title_ar : language === 'fr' ? article.title_fr : article.title_en}
                  className={`new-article-image ${article.isSpecial ? 'special-logo' : ''}`}
                />
              </div>
              <div className="new-article-info">
                <h3 className="new-article-title">
                  {language === 'ar' ? article.title_ar : language === 'fr' ? article.title_fr : article.title_en}
                </h3>
                <p className="new-article-author">
                  {language === 'ar' ? article.author_ar : language === 'fr' ? article.author_fr : article.author_en}
                </p>
                {article.link === '#' ? (
                  <button 
                    onClick={() => openModal(article.image)}
                    className="read-article-btn"
                  >
                    {language === 'ar' ? 'اقرأ المقال' : language === 'fr' ? "Lire l'article" : 'Read Article'}
                  </button>
                ) : (
                  <a 
                    href={article.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="read-article-btn"
                  >
                    {article.isSpecial ? (
                      language === 'ar' ? 'تصفح المقالات' : language === 'fr' ? 'Consulter les articles' : 'View all articles'
                    ) : (
                      language === 'ar' ? 'اقرأ المقال' : language === 'fr' ? "Lire l'article" : 'Read Article'
                    )}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-nav-btn next" onClick={() => scroll('right')}>&#8250;</button>
      </div>

      {selectedImage && (
        <div className="article-modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>&times;</button>
            <img src={selectedImage} alt="Article Detail" className="modal-image" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Articles;
